<div class="wrapper">
  <img src="assets/404.jpg" />
  <p>Oh no ... something went wrong. This page does not exist.</p>
</div>
